(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hl-cainiao-tracking"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll("[data-hl-tracking]");

  function parseJson(node) {
    try { return JSON.parse(node.textContent || "{}"); } catch (error) { return {}; }
  }

  function shipmentList(data) {
    if (!data) return [];
    const candidates = [
      data.module,
      data.shipments,
      data.packages,
      data.trackingModules,
      data.modules
    ];
    for (const candidate of candidates) {
      if (Array.isArray(candidate)) return candidate;
      if (candidate && Array.isArray(candidate.nodes)) return candidate.nodes;
    }
    return [];
  }

  function firstShipment(data, index = 0) {
    const list = shipmentList(data);
    return list[index] || list[0] || null;
  }

  function setText(root, selector, value) {
    const node = root.querySelector(selector);
    if (node) node.textContent = value || "";
  }

  function parseCarrierTime(timeStr, timeZone) {
    const match = String(timeStr || "").match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (!match) return null;
    const zone = String(timeZone || "").trim();
    const zoneMatch = zone.match(/(?:GMT|UTC)?\s*([+-])(\d{1,2})(?::?(\d{2}))?/i);
    if (!zoneMatch) return null;
    const sign = zoneMatch[1] === "+" ? 1 : -1;
    const offsetMinutes = sign * (Number(zoneMatch[2]) * 60 + Number(zoneMatch[3] || 0));
    const utc = Date.UTC(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4]),
      Number(match[5]),
      Number(match[6] || 0)
    ) - offsetMinutes * 60000;
    const date = new Date(utc);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function formatClientTime(timeStr, timeZone, locale) {
    const date = parseCarrierTime(timeStr, timeZone);
    if (!date) return String(timeStr || "");
    const options = {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short"
    };
    if (date.getFullYear() !== new Date().getFullYear()) options.year = "numeric";
    try {
      return new Intl.DateTimeFormat(locale || undefined, options).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat(undefined, options).format(date);
    }
  }

  function initials(value) {
    return String(value || "HL").split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part.charAt(0)).join("").toUpperCase() || "HL";
  }

  function sanitizeTrackingText(value) {
    let text = String(value || "").trim();
    if (!text) return "";
    const chinaLocation = /\b(?:Mainland China|China|Shenzhen|Guangzhou|Dongguan|Yiwu|Hangzhou|Shanghai|Beijing|Hefei|Foshan|Xiamen|Ningbo|Zhengzhou|Nanchang|Wuhan|Chengdu|Chongqing|Suzhou|Qingdao|Tianjin)\b/i;
    if (chinaLocation.test(text)) {
      text = text.replace(/^\[[^\]]+\]\s*/, "");
      text = text.replace(/\([^)]*(?:Mainland China|China|Shenzhen|Guangzhou|Dongguan|Yiwu|Hangzhou|Shanghai|Beijing|Hefei|Foshan|Xiamen|Ningbo|Zhengzhou|Nanchang|Wuhan|Chengdu|Chongqing|Suzhou|Qingdao|Tianjin)[^)]*\)/gi, "");
      text = text.replace(/\b(?:Mainland China|China|Shenzhen|Guangzhou|Dongguan|Yiwu|Hangzhou|Shanghai|Beijing|Hefei|Foshan|Xiamen|Ningbo|Zhengzhou|Nanchang|Wuhan|Chengdu|Chongqing|Suzhou|Qingdao|Tianjin)\b/gi, "origin facility");
    }
    text = text
      .replace(/\bCainiao\b/gi, "shipping partner")
      .replace(/\bAliExpress\b/gi, "shipping partner")
      .replace(/export customs clearance/gi, "international transit processing")
      .replace(/departed from (?:the )?origin country\/region sorting center/gi, "departed from origin sorting center")
      .replace(/left (?:the )?departure country\/region sorting center/gi, "departed from origin sorting center")
      .replace(/arrived at (?:the )?departure transport hub/gi, "arrived at international transit hub")
      .replace(/\s{2,}/g, " ")
      .replace(/\s+,/g, ",")
      .trim();
    return text;
  }

  function isPrivateCarrier(carrier) {
    const name = String(carrier && (carrier.cpName || carrier.name) || "");
    return /cainiao|aliexpress|china post|4px|yanwen|yunexpress|sunyou/i.test(name);
  }

  function normalizeStatus(shipment, i18n) {
    const text = shipment.statusDesc || shipment.status || "";
    const group = shipment.latestTrace && shipment.latestTrace.group && shipment.latestTrace.group.nodeDesc;
    const merged = `${text} ${group || ""}`.toLowerCase();
    if (merged.includes("out for delivery") || merged.includes("with courier")) return i18n.outForDelivery;
    if (/\bdelivered\b|delivery successful|successfully delivered|signed for/.test(merged)) return i18n.delivered;
    if (merged.includes("pickup") || merged.includes("pick up") || merged.includes("picked up")) return i18n.pickUp;
    if (merged.includes("info received") || merged.includes("information received")) return i18n.infoReceived;
    return sanitizeTrackingText(group || text) || i18n.inTransit;
  }

  function trackingData(data) {
    return data && data.tracking ? data.tracking : data;
  }

  function orderData(data) {
    return data && (data.order || data.shopifyOrder || data.orderData) ? (data.order || data.shopifyOrder || data.orderData) : null;
  }

  function listNodes(value) {
    if (Array.isArray(value)) return value;
    if (value && Array.isArray(value.nodes)) return value.nodes;
    if (value && Array.isArray(value.edges)) return value.edges.map((edge) => edge && edge.node).filter(Boolean);
    return [];
  }

  function moneyValue(value) {
    if (value == null) return null;
    if (typeof value === "number" || typeof value === "string") {
      const amount = Number(value);
      return Number.isFinite(amount) ? { amount, currencyCode: "USD" } : null;
    }
    if (value.amount != null) {
      const amount = Number(value.amount);
      if (!Number.isFinite(amount)) return null;
      return { amount, currencyCode: value.currencyCode || value.currency || "USD" };
    }
    return moneyValue(
      value.presentmentMoney ||
      value.shopMoney ||
      value.money ||
      value.price ||
      value.value
    );
  }

  function formatMoney(value) {
    const money = moneyValue(value);
    if (!money) return "";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: money.currencyCode || "USD"
      }).format(money.amount);
    } catch (error) {
      return `${money.amount.toFixed(2)} ${money.currencyCode || "USD"}`;
    }
  }

  function trackingNumbersForFulfillment(fulfillment) {
    if (!fulfillment) return [];
    const info = listNodes(fulfillment.trackingInfo || fulfillment.tracking_info);
    const numbers = info
      .map((item) => item && (item.number || item.trackingNumber || item.tracking_number))
      .filter(Boolean);
    if (Array.isArray(fulfillment.trackingNumbers)) numbers.push(...fulfillment.trackingNumbers);
    if (fulfillment.trackingNumber) numbers.push(fulfillment.trackingNumber);
    if (fulfillment.tracking_number) numbers.push(fulfillment.tracking_number);
    return numbers.map((value) => String(value).trim()).filter(Boolean);
  }

  function normalizeOrderProduct(raw) {
    if (!raw) return null;
    const line = raw.lineItem || raw.line_item || raw;
    const image =
      line.image ||
      (line.variant && line.variant.image) ||
      (line.product && (line.product.featuredImage || line.product.image)) ||
      raw.image ||
      null;
    const price = moneyValue(
      line.discountedUnitPriceAfterAllDiscountsSet ||
      line.discountedUnitPriceSet ||
      line.discountedUnitPrice ||
      line.priceSet ||
      line.price ||
      raw.price
    );
    const compareAt = moneyValue(
      line.originalUnitPriceSet ||
      line.originalUnitPrice ||
      line.compareAtPriceSet ||
      line.compareAt ||
      line.compareAtPrice ||
      raw.compareAt
    );
    const quantity = Number(raw.quantity != null ? raw.quantity : (line.currentQuantity != null ? line.currentQuantity : line.quantity || 1));
    const variantTitle = line.variantTitle || (line.variant && line.variant.title) || raw.variantTitle || "";
    return {
      id: line.id || raw.id || "",
      productId: line.productId || raw.productId || (line.product && line.product.id) || "",
      title: line.title || line.productTitle || line.name || raw.title || "",
      variantTitle: variantTitle === "Default Title" ? "" : variantTitle,
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
      image: image && (image.url || image.src) ? {
        url: image.url || image.src,
        altText: image.altText || image.alt || line.title || ""
      } : null,
      price,
      compareAt,
      formattedPrice: line.formattedPrice || raw.formattedPrice || "",
      formattedCompareAt: line.formattedCompareAt || raw.formattedCompareAt || "",
      url: line.url || line.productUrl || (line.product && (line.product.onlineStoreUrl || line.product.url)) || raw.url || ""
    };
  }

  function productsForShipment(order, shipment) {
    if (!order) return { products: [], shipmentSpecific: false };

    const shipmentMailNo = String(shipment && shipment.mailNo || "").trim();
    const fulfillments = listNodes(order.fulfillments || order.shipments);
    let matchedFulfillment = null;

    if (shipmentMailNo) {
      matchedFulfillment = fulfillments.find((fulfillment) =>
        trackingNumbersForFulfillment(fulfillment).some((number) => number === shipmentMailNo)
      ) || null;
    }
    if (!matchedFulfillment && fulfillments.length === 1) matchedFulfillment = fulfillments[0];

    if (matchedFulfillment) {
      const fulfillmentItems = listNodes(
        matchedFulfillment.fulfillmentLineItems ||
        matchedFulfillment.lineItems ||
        matchedFulfillment.items ||
        matchedFulfillment.products
      );
      const products = fulfillmentItems.map(normalizeOrderProduct).filter((product) => product && product.title);
      if (products.length) return { products, shipmentSpecific: true };
    }

    const shipmentItems = listNodes(shipment && (shipment.products || shipment.items || shipment.lineItems));
    const shipmentProducts = shipmentItems.map(normalizeOrderProduct).filter((product) => product && product.title);
    if (shipmentProducts.length) return { products: shipmentProducts, shipmentSpecific: true };

    const directItems = listNodes(order.products || order.items || order.lineItems);
    const products = directItems.map(normalizeOrderProduct).filter((product) => product && product.title);
    return {
      products,
      shipmentSpecific: Boolean(order.productsAreShipped)
    };
  }

  function orderTotal(order) {
    if (!order) return null;
    return moneyValue(
      order.currentTotalPriceSet ||
      order.currentTotalPrice ||
      order.totalPriceSet ||
      order.totalPrice ||
      order.total ||
      order.price
    );
  }

  function renderProducts(root, order, i18n, shipment, shipmentIndex = 0, shipmentCount = 1) {
    const list = root.querySelector("[data-order-products]");
    const heading = root.querySelector("[data-order-products-heading]");
    const totalRow = root.querySelector("[data-order-total-row]");
    const totalNode = root.querySelector("[data-order-total]");
    if (!list) return;

    const result = productsForShipment(order, shipment);
    const products = result.products;
    list.hidden = products.length === 0;

    if (heading) {
      heading.hidden = products.length === 0;
      heading.textContent = result.shipmentSpecific
        ? (shipmentCount > 1 ? `Items in Package #${shipmentIndex + 1}` : i18n.shippedItems)
        : i18n.orderItems;
    }

    const total = orderTotal(order);
    const totalText = order && order.formattedTotal ? order.formattedTotal : (total ? formatMoney(total) : "");
    if (totalRow) totalRow.hidden = !totalText;
    if (totalNode) totalNode.textContent = totalText;

    list.innerHTML = "";
    products.forEach((product) => {
      const li = document.createElement("li");
      li.className = "hltr__product";

      const media = document.createElement("div");
      media.className = "hltr__product-img";
      if (product.image && product.image.url) {
        const img = document.createElement("img");
        img.src = product.image.url;
        img.alt = product.image.altText || product.title || "";
        img.loading = "lazy";
        media.append(img);
      }

      const body = document.createElement("div");
      body.className = "hltr__product-body";
      const top = document.createElement("div");
      top.className = "hltr__product-title";

      const title = product.url ? document.createElement("a") : document.createElement("span");
      if (product.url) title.href = product.url;
      title.textContent = product.title || "";

      const priceWrap = document.createElement("span");
      priceWrap.className = "hltr__product-price";
      const currentPriceText = product.formattedPrice || (product.price ? formatMoney(product.price) : "");
      if (currentPriceText) {
        const current = document.createElement("span");
        current.textContent = currentPriceText;
        priceWrap.append(current);
      }

      const priceMoney = moneyValue(product.price);
      const compareMoney = moneyValue(product.compareAt);
      const comparePriceText = product.formattedCompareAt || (compareMoney ? formatMoney(compareMoney) : "");
      const shouldShowCompare = product.formattedCompareAt
        ? Boolean(comparePriceText && comparePriceText !== currentPriceText)
        : Boolean(priceMoney && compareMoney && compareMoney.amount > priceMoney.amount + 0.001);
      if (shouldShowCompare) {
        const strike = document.createElement("s");
        strike.textContent = comparePriceText;
        priceWrap.append(strike);
      }

      top.append(title, priceWrap);

      const meta = document.createElement("div");
      meta.className = "hltr__product-meta";
      const details = document.createElement("span");
      details.textContent = [product.variantTitle, `× ${product.quantity || 1}`].filter(Boolean).join(" · ");
      meta.append(details);

      body.append(top, meta);
      li.append(media, body);
      list.append(li);
    });

    const relatedProduct = products.find((product) => product.productId);
    if (relatedProduct) loadRelatedProducts(root, relatedProduct.productId);
  }

  function render(root, data, mailNo, i18n, shipmentIndex = 0) {
    const tracking = trackingData(data);
    const order = orderData(data);
    const shipments = shipmentList(tracking);
    const shipment = firstShipment(tracking, shipmentIndex);
    const panel = root.querySelector("[data-hl-track-panel]");
    if (panel) {
      panel.hidden = false;
      panel.classList.remove("is-loading");
    }

    const fallback = root.querySelector("[data-fallback-17track]");
    if (fallback) fallback.hidden = true;

    if (!shipment) {
      root.dataset.currentTracking = "";
      if (fallback && mailNo && !order) {
        const link = fallback.querySelector("[data-fallback-link]");
        if (link) link.href = i18n.fallbackUrl + encodeURIComponent(mailNo);
        fallback.hidden = false;
      }
      const packageTabs = root.querySelector(".hltr__package-tabs");
      if (packageTabs) packageTabs.hidden = true;
      renderProducts(root, order, i18n, shipment, shipmentIndex, shipments.length);
      setText(root, "[data-primary-status]", data && data.error ? data.error : i18n.notFound);
      setText(root, "[data-status-heading]", data && data.error ? data.error : i18n.notFound);
      setText(root, "[data-latest-desc]", data && data.error ? data.error : i18n.notFound);
      setText(root, "[data-order-destination]", order && (order.country || order.destination) || i18n.unknown);
      setText(root, "[data-order-days]", "");
      setText(root, "[data-order-number-label]", order ? i18n.orderNumber : i18n.trackingNumber);
      setText(root, "[data-order-number]", order && order.name || mailNo);
      const timeline = root.querySelector("[data-timeline]");
      if (timeline) timeline.innerHTML = "";
      const showMore = root.querySelector("[data-show-more]");
      if (showMore) showMore.hidden = true;
      return;
    }

    const packageTabs = root.querySelector(".hltr__package-tabs");
    if (packageTabs) {
      packageTabs.innerHTML = "";
      packageTabs.hidden = shipments.length <= 1;
      shipments.forEach((item, index) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = index === shipmentIndex ? "is-active" : "";
        button.textContent = (i18n.packageOne || "Package #1").replace(/#?1\b/, `#${index + 1}`);
        button.setAttribute("aria-pressed", index === shipmentIndex ? "true" : "false");
        button.addEventListener("click", () => render(root, data, mailNo, i18n, index));
        packageTabs.append(button);
      });
    }

    root.dataset.currentTracking = shipment.mailNo || mailNo || "";
    const details = Array.isArray(shipment.detailList) ? shipment.detailList : [];
    if (fallback && !details.length && !order) {
      const link = fallback.querySelector("[data-fallback-link]");
      if (link) link.href = i18n.fallbackUrl + encodeURIComponent(shipment.mailNo || mailNo);
      fallback.hidden = false;
    }
    const latest = shipment.latestTrace || details[0] || {};
    const progress = shipment.processInfo || {};
    const rate = Math.max(0.02, Math.min(1, Number(progress.progressRate || 0.1)));
    const statusText = normalizeStatus(shipment, i18n);
    const statusLower = statusText.toLowerCase();
    const statusIcon = root.querySelector("[data-status-icon]");
    const delivered = statusLower.includes("delivered") && !statusLower.includes("delivery");
    let currentIndex = delivered ? 4 : 2;
    if (!delivered && (statusLower.includes("out for delivery") || rate >= 0.68)) currentIndex = 3;
    if (!delivered && rate < 0.34) currentIndex = 1;
    if (!delivered && rate < 0.16) currentIndex = 0;
    const progressSteps = [
      i18n.orderPending,
      i18n.infoReceived,
      i18n.inTransit,
      statusLower.includes("pick up") || statusLower.includes("picked up") ? i18n.pickUp : i18n.outForDelivery,
      i18n.delivered
    ];
    const progressPercent = currentIndex / (progressSteps.length - 1) * 100;

    setText(root, "[data-mail-no]", shipment.mailNo || mailNo);
    setText(root, "[data-primary-status]", statusText);
    setText(root, "[data-status-heading]", statusText);
    setText(root, "[data-origin]", i18n.inTransit);
    setText(root, "[data-destination]", shipment.destCountry || i18n.unknown);
    setText(root, "[data-latest-time]", latest.timeStr ? formatClientTime(latest.timeStr, latest.timeZone, root.dataset.locale) : "");
    setText(root, "[data-latest-desc]", sanitizeTrackingText(latest.standerdDesc || latest.desc || statusText));
    setText(root, "[data-days]", shipment.daysNumber || "");
    setText(root, "[data-count-delivered]", delivered ? "1" : "0");
    setText(root, "[data-count-transit]", delivered ? "0" : "1");
    setText(root, "[data-order-destination]", order && (order.country || order.destination) || shipment.destCountry || i18n.unknown);
    setText(root, "[data-order-days]", shipment.daysNumber || "");
    setText(root, "[data-order-number-label]", order ? i18n.orderNumber : i18n.trackingNumber);
    setText(root, "[data-order-number]", order && order.name || shipment.mailNo || mailNo);
    renderProducts(root, order, i18n, shipment, shipmentIndex, shipments.length);

    if (statusIcon) {
      statusIcon.classList.toggle("is-delivered", delivered);
      statusIcon.classList.toggle("is-warn", statusLower.includes("fail") || statusLower.includes("exception"));
      const path = statusIcon.querySelector("path");
      if (path) path.setAttribute("d", delivered ? "M5 12l4 4L19 6" : "M5 12h14m-5-5 5 5-5 5");
    }

    const progressWrap = root.querySelector(".hltr__progress");
    if (progressWrap) progressWrap.classList.toggle("is-processing", !delivered);
    const fill = root.querySelector("[data-progress-fill]");
    if (fill) fill.style.width = `${progressPercent}%`;
    const progressNote = root.querySelector("[data-progress-note]");
    if (progressNote) {
      if (!progressNote.dataset.defaultText) progressNote.dataset.defaultText = progressNote.textContent || "";
      progressNote.textContent = delivered ? i18n.deliveredNote : progressNote.dataset.defaultText;
    }

    const steps = root.querySelector("[data-progress-steps]");
    if (steps) {
      steps.innerHTML = "";
      progressSteps.forEach((label, index) => {
        const li = document.createElement("li");
        li.style.left = `${index / (progressSteps.length - 1) * 100}%`;
        if (index === 0) li.classList.add("is-first");
        if (index === progressSteps.length - 1) li.classList.add("is-last");
        if (index < currentIndex || (delivered && index === currentIndex)) li.classList.add("is-done");
        if (!delivered && index === currentIndex) {
          li.classList.add("is-current");
          li.setAttribute("aria-current", "step");
        }
        const marker = document.createElement("span");
        marker.className = "hltr__step-marker";
        marker.setAttribute("aria-hidden", "true");
        if (index < currentIndex || (delivered && index === currentIndex)) {
          const check = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          check.setAttribute("viewBox", "0 0 12 12");
          const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
          path.setAttribute("d", "M2.5 6.25 5 8.5 9.5 3.5");
          check.append(path);
          marker.append(check);
        }
        const span = document.createElement("span");
        span.textContent = label || "";
        li.append(marker, span);
        steps.append(li);
      });
    }

    const carrier = shipment.currentStatusCpInfo || shipment.destCpInfo || {};
    const carrierRow = root.querySelector("[data-carrier-row]");
    const carrierLinks = root.querySelectorAll("[data-carrier-link]");
    const privateCarrier = isPrivateCarrier(carrier);
    if (carrierRow) carrierRow.hidden = true;
    if (carrierRow && carrier.cpName && !privateCarrier) {
      carrierRow.hidden = false;
      setText(root, "[data-carrier-name]", carrier.cpName);
      setText(root, "[data-carrier-meta]", "");
      setText(root, "[data-carrier-track]", shipment.mailNo || mailNo);
      setText(root, "[data-carrier-logo]", initials(carrier.cpName));
    }
    carrierLinks.forEach((carrierLink) => {
      const usefulLink = carrier.url && !privateCarrier;
      carrierLink.hidden = !usefulLink;
      if (usefulLink) carrierLink.href = carrier.url;
      else carrierLink.removeAttribute("href");
    });

    const timeline = root.querySelector("[data-timeline]");
    if (timeline) {
      timeline.innerHTML = "";
      details.forEach((item, index) => {
        const li = document.createElement("li");
        li.className = "hltr__event";
        if (index === 0 && !delivered) li.classList.add("is-current");
        if (index >= 8) li.classList.add("is-hidden");
        const time = document.createElement("time");
        time.textContent = item.timeStr ? formatClientTime(item.timeStr, item.timeZone, root.dataset.locale) : "";
        const parsedTime = parseCarrierTime(item.timeStr, item.timeZone);
        if (parsedTime) time.dateTime = parsedTime.toISOString();
        const dot = document.createElement("i");
        dot.className = "hltr__dot";
        dot.setAttribute("aria-hidden", "true");
        const body = document.createElement("div");
        const strong = document.createElement("strong");
        strong.textContent = sanitizeTrackingText(item.standerdDesc || item.desc || i18n.carrierNote);
        const span = document.createElement("span");
        span.textContent = sanitizeTrackingText(item.group && item.group.nodeDesc ? item.group.nodeDesc : item.descTitle || "");
        body.append(strong, span);
        li.append(time, dot, body);
        timeline.append(li);
      });
    }

    const showMore = root.querySelector("[data-show-more]");
    if (showMore) {
      const hiddenEvents = Array.from(root.querySelectorAll(".hltr__event")).slice(8);
      showMore.hidden = hiddenEvents.length === 0;
      showMore.textContent = i18n.showMore;
      showMore.dataset.expanded = "false";
      showMore.onclick = () => {
        const expanded = showMore.dataset.expanded === "true";
        hiddenEvents.forEach((event) => event.classList.toggle("is-hidden", expanded));
        showMore.dataset.expanded = expanded ? "false" : "true";
        showMore.textContent = expanded ? i18n.showMore : i18n.showLess;
      };
    }
  }

  async function load(root, request, i18n) {
    const panel = root.querySelector("[data-hl-track-panel]");
    if (panel) {
      panel.hidden = false;
      panel.classList.add("is-loading");
    }
    setText(root, "[data-primary-status]", i18n.loading);
    const proxy = root.dataset.proxyUrl || "";
    const value = request.value || "";
    let data;
    if (proxy) {
      const url = new URL(proxy, window.location.href);
      if (request.mode === "order") {
        url.searchParams.set("order", normalizeOrderNumber(value));
        url.searchParams.set("email", request.email || "");
      } else {
        url.searchParams.set("mailNos", value);
      }
      url.searchParams.set("lang", root.dataset.locale || "en-US");
      const response = await fetch(url.toString(), {
        headers: { "Accept": "application/json" },
        cache: "no-store",
        credentials: "omit"
      });
      data = await response.json();
      if (!response.ok || data.success === false) throw new Error(data.error || i18n.error);
    } else {
      throw new Error(i18n.error);
    }
    if (request.orderData) data.order = request.orderData;
    render(root, data, value, i18n);
  }

  function normalizeProductId(value) {
    const match = String(value || "").match(/(\d+)(?!.*\d)/);
    return match ? match[1] : "";
  }

  async function loadRelatedProducts(root, productId) {
    const id = normalizeProductId(productId);
    const wrap = root.querySelector("[data-related-products]");
    const grid = root.querySelector("[data-related-grid]");
    if (!id || !wrap || !grid || !root.dataset.recommendationsUrl || !root.dataset.sectionId) return;
    if (wrap.dataset.productId === id && !wrap.hidden) return;

    try {
      const url = new URL(root.dataset.recommendationsUrl, window.location.origin);
      url.searchParams.set("section_id", root.dataset.sectionId);
      url.searchParams.set("product_id", id);
      url.searchParams.set("limit", "4");
      url.searchParams.set("intent", "related");
      const response = await fetch(url.toString(), { headers: { "Accept": "text/html" }, cache: "no-store" });
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const source = doc.querySelector("[data-related-products-source]");
      if (!source || !source.children.length) return;
      grid.innerHTML = source.innerHTML;
      wrap.dataset.productId = id;
      wrap.hidden = false;
    } catch (error) {
      wrap.hidden = true;
    }
  }

  function normalizeOrderNumber(value) {
    const cleaned = String(value || "").trim().replace(/^#+/, "");
    return cleaned ? `#${cleaned}` : "#";
  }

  function syncTrackingUrl(mode, value) {
    const url = new URL(window.location.href);
    ["tracking", "mailNos", "order", "order_number", "email"].forEach((key) => url.searchParams.delete(key));

    if (mode === "tracking") {
      const tracking = String(value || "").trim();
      if (tracking) url.searchParams.set("tracking", tracking);
    } else if (mode === "order") {
      const order = normalizeOrderNumber(value);
      if (order !== "#") url.searchParams.set("order", order);
    }

    const next = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState({}, "", next);
  }

  roots.forEach((root) => {
    const i18n = parseJson(root.querySelector("[data-hl-track-i18n]"));
    try { root.dataset.clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch (error) { root.dataset.clientTimezone = ""; }
    const form = root.querySelector("[data-hl-track-form]");
    const trackingInput = root.querySelector("[data-tracking-input]");
    const orderInput = root.querySelector("[data-order-input]");
    const emailInput = root.querySelector("[data-email-input]");
    const tabs = root.querySelectorAll("[data-track-tab]");
    const fieldSets = root.querySelectorAll("[data-track-fields]");
    const accountOrders = root.querySelector("[data-account-orders]");
    const hint = root.querySelector("[data-hl-track-hint]");
    const signedIn = root.dataset.customerLoggedIn === "true";
    let mode = "order";

    function syncOrderPrefix() {
      if (!orderInput || signedIn) return;
      const normalized = normalizeOrderNumber(orderInput.value);
      if (orderInput.value !== normalized) orderInput.value = normalized;
      if (mode !== "order") {
        orderInput.setCustomValidity("");
        return;
      }
      orderInput.setCustomValidity(normalized === "#" ? "Enter your order number." : "");
    }

    if (orderInput && !signedIn) {
      if (!orderInput.value) orderInput.value = "#";
      syncOrderPrefix();
      orderInput.addEventListener("input", () => {
        syncOrderPrefix();
        if (mode === "order") syncTrackingUrl("order", orderInput.value);
      });
      orderInput.addEventListener("focus", syncOrderPrefix);
      orderInput.addEventListener("blur", () => {
        syncOrderPrefix();
        if (mode === "order") syncTrackingUrl("order", orderInput.value);
      });
    }

    if (trackingInput) {
      trackingInput.addEventListener("input", () => {
        if (mode === "tracking") syncTrackingUrl("tracking", trackingInput.value);
      });
      trackingInput.addEventListener("blur", () => {
        if (mode === "tracking") syncTrackingUrl("tracking", trackingInput.value);
      });
    }

    function setMode(nextMode) {
      mode = nextMode;
      const tabRail = root.querySelector(".hltr__form-tabs");
      if (tabRail) tabRail.dataset.active = mode;
      tabs.forEach((tab) => {
        const active = tab.dataset.trackTab === mode;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });
      fieldSets.forEach((fields) => {
        fields.hidden = fields.dataset.trackFields !== mode;
      });

      const accountMode = signedIn && mode === "order";
      if (form) form.hidden = accountMode;
      if (accountOrders) accountOrders.hidden = !accountMode;
      if (hint) hint.hidden = accountMode;

      if (trackingInput) {
        trackingInput.required = !accountMode && mode === "tracking";
        trackingInput.disabled = mode !== "tracking";
      }
      if (orderInput) {
        orderInput.required = !accountMode && mode === "order";
        orderInput.disabled = accountMode || mode !== "order";
        if (mode === "order" && !accountMode) syncOrderPrefix();
        else orderInput.setCustomValidity("");
      }
      if (emailInput) {
        emailInput.required = !accountMode && mode === "order";
        emailInput.disabled = accountMode || mode !== "order";
        emailInput.setCustomValidity("");
      }
      if (!accountMode) setText(root, "[data-hl-track-hint]", mode === "order" ? i18n.orderLookupNote : i18n.sourceNote);
    }

    setMode("order");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        const nextMode = tab.dataset.trackTab || "tracking";
        setMode(nextMode);
        syncTrackingUrl(nextMode, nextMode === "order" ? (orderInput && orderInput.value) : (trackingInput && trackingInput.value));
      });
      tab.addEventListener("keydown", (event) => {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        const direction = event.key === "ArrowRight" ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        if (next) {
          const nextMode = next.dataset.trackTab || "tracking";
          setMode(nextMode);
          syncTrackingUrl(nextMode, nextMode === "order" ? (orderInput && orderInput.value) : (trackingInput && trackingInput.value));
          next.focus();
        }
      });
    });

    const params = new URLSearchParams(window.location.search);
    const queryOrder = params.get("order") || params.get("order_number") || "";
    const queryEmail = params.get("email") || "";
    const queryTracking = params.get("tracking") || params.get("mailNos") || "";
    if (params.has("email")) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("email");
      window.history.replaceState({}, "", `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
    }
    const defaultMailNo = queryTracking || root.dataset.defaultMailNo || (trackingInput && trackingInput.value) || "";

    if (queryOrder && !signedIn) {
      setMode("order");
      if (orderInput) {
        orderInput.value = normalizeOrderNumber(queryOrder);
        syncOrderPrefix();
      }
      if (emailInput) emailInput.value = queryEmail;
      if (queryEmail) load(root, { mode: "order", value: queryOrder, email: queryEmail }, i18n).catch((error) => {
        setText(root, "[data-primary-status]", error.message || i18n.error);
        setText(root, "[data-latest-desc]", i18n.error);
      });
    } else if (defaultMailNo) {
      setMode("tracking");
      load(root, { mode: "tracking", value: defaultMailNo }, i18n).catch((error) => {
        render(root, { error: error.message || i18n.error }, defaultMailNo, i18n);
      });
    }

    function accountProducts(packageNode) {
      return Array.from(packageNode.querySelectorAll("[data-account-product]")).map((item) => ({
        productId: item.dataset.productId || "",
        title: item.dataset.productTitle || "",
        variantTitle: item.dataset.productVariant || "",
        quantity: Number(item.dataset.productQuantity || 1),
        formattedPrice: item.dataset.productPrice || "",
        formattedCompareAt: item.dataset.productCompare || "",
        image: item.dataset.productImage ? { url: item.dataset.productImage, altText: item.dataset.productTitle || "" } : null
      }));
    }

    function accountOrderData(button) {
      const orderNode = button.closest("[data-account-order]");
      const currentPackage = button.closest("[data-account-package]");
      if (!orderNode || !currentPackage) return null;

      const fulfillments = Array.from(orderNode.querySelectorAll("[data-account-package]")).map((packageNode) => {
        const number = String(packageNode.dataset.trackingNumber || "").trim();
        const products = accountProducts(packageNode);
        return {
          trackingInfo: number ? [{ number }] : [],
          fulfillmentLineItems: products.map((product) => ({
            quantity: product.quantity,
            lineItem: product
          }))
        };
      });

      const products = accountProducts(currentPackage);
      return {
        name: orderNode.dataset.orderName || "",
        country: orderNode.dataset.orderDestination || "",
        destination: orderNode.dataset.orderDestination || "",
        formattedTotal: orderNode.dataset.orderTotal || "",
        fulfillments,
        products,
        productsAreShipped: true
      };
    }

    if (signedIn) {
      const firstPurchasedProduct = root.querySelector("[data-account-product][data-product-id]");
      if (firstPurchasedProduct && firstPurchasedProduct.dataset.productId) {
        loadRelatedProducts(root, firstPurchasedProduct.dataset.productId);
      }
    }

    root.querySelectorAll("[data-account-track]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const tracking = String(button.dataset.trackingNumber || "").trim();
        if (!tracking) return;
        syncTrackingUrl("tracking", tracking);
        const orderData = accountOrderData(button);
        load(root, { mode: "tracking", value: tracking, orderData }, i18n).then(() => {
          const panel = root.querySelector("[data-hl-track-panel]");
          if (panel) panel.scrollIntoView({ behavior: "smooth", block: "start" });
        }).catch((error) => {
          render(root, { error: error.message || i18n.error, order: orderData }, tracking, i18n);
        });
      });
    });

    if (form) {
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        if (mode === "order") syncOrderPrefix();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        const value = mode === "order"
          ? normalizeOrderNumber(orderInput && orderInput.value)
          : String(trackingInput && trackingInput.value || "").trim();
        const email = String(emailInput && emailInput.value || "").trim();
        if (mode === "order" && value === "#") {
          if (orderInput) {
            orderInput.setCustomValidity("Enter your order number.");
            orderInput.reportValidity();
          }
          return;
        }
        if (mode === "order" && !email) {
          syncTrackingUrl("order", value);
          setText(root, "[data-primary-status]", i18n.emailRequired);
          setText(root, "[data-latest-desc]", i18n.emailRequired);
          return;
        }
        if (value) {
          syncTrackingUrl(mode, value);
          load(root, { mode, value, email }, i18n).catch((error) => {
            render(root, { error: error.message || i18n.error }, value, i18n);
          });
        }
      });
    }

    const copyDetails = root.querySelector("[data-copy-details]");
    const copyLink = root.querySelector("[data-copy-link]");
    if (copyDetails) copyDetails.addEventListener("click", async () => {
      const label = copyDetails.textContent;
      const text = Array.from(root.querySelectorAll(".hltr__event")).map((item) => item.textContent.trim()).join("\n");
      await navigator.clipboard.writeText(text);
      copyDetails.textContent = i18n.copyOk;
      window.setTimeout(() => { copyDetails.textContent = label; }, 1400);
    });
    if (copyLink) copyLink.addEventListener("click", async () => {
      const label = copyLink.textContent;
      const shareUrl = new URL(window.location.href);
      shareUrl.search = "";
      const currentTracking = root.dataset.currentTracking || "";
      if (currentTracking) shareUrl.searchParams.set("tracking", currentTracking);
      await navigator.clipboard.writeText(shareUrl.toString());
      copyLink.textContent = i18n.copyOk;
      window.setTimeout(() => { copyLink.textContent = label; }, 1400);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
